import React from 'react';
import { Card } from 'ui';

function ProductsCardLoader() {
  return (
    <Card flat>
      <Card.Content>
        <div className="relative flex flex-wrap gap-x-4 gap-y-2">
          <div className="h-32 w-32 flex-grow-0 animate-pulse rounded-lg bg-gray-100" />
          <div className="flex-grow space-y-3">
            <div className="flex flex-wrap justify-between gap-1">
              <div className="flex h-12 w-1/2 animate-pulse rounded-lg bg-gray-100" />
            </div>

            <div className="h-16 w-3/4 animate-pulse space-y-4 rounded-lg bg-gray-100" />
          </div>
        </div>
      </Card.Content>
    </Card>
  );
}

export default ProductsCardLoader;
